import classNames from "classnames";

const DndIndicator = ({ layout = "vertical" }) => (
  <div
    className={classNames(
      "neeto-ui-rounded-xl neeto-ui-bg-accent-600 absolute",
      {
        "-bottom-3 end-0 start-0 h-1": layout === "horizontal",
        "-end-2 bottom-0 top-0 w-1": layout === "vertical",
      }
    )}
  />
);

export default DndIndicator;
